
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: { slideInfo },

  data() {
    return {
      stageList: [
        { title: '孕中期', desc: '最快2小时可面试月嫂,视频面试/线下月嫂见面,协助您找到好月嫂#选定月嫂，支付定金即可开启妈妈来了团队服务#妈妈来了服务团队24小时在线服务，有问题随时咨询' },
        { title: '孕后期', desc: '临近生产，医护专家提供微信/电话指导，如待产包准备、生产前心理建设等' },
        { title: '生产前', desc: '进产房开6指前或剖腹产提前告知生产时间给团队，通知月嫂到岗开始服务#住院期间月嫂24小时陪护' },
        { title: '生产后', desc: '出院后，月嫂24小时住家服务，提供全面呵护#月子服务期间，售后团队24小时在线跟进，有问题可随时反馈' },
        { title: '月子期', desc: '月嫂对家人进行育儿技能传递，帮助新手家庭建立育儿信心#妈妈来了母乳指导团队线上、线下助力实现母乳喂养' },
        { title: '月子结束', desc: '月嫂服务结束,宝妈可对其服务做出评价#宝宝百日、1岁、2岁、3岁的生日关怀#幼儿理念传递' },
      ]
    };
  }
});
